import { createAction, handleActions } from 'redux-actions';
import { isRuleEngineAdmin } from '../utils/rbac';

// ACTION CREATORS
export const getLogin = createAction('GET_LOGIN');
export const setLogin = createAction('SET_LOGIN');
export const createSession = createAction('CREATE_SESSION');
export const getCurrentUser = createAction('GET_CURRENT_USER');

// REDUCERS
export const reducer = handleActions(
  new Map([
    [
        setLogin,
      (state, action) => {
        return action.payload
      } 
    ]
  ]),
  {
    isLoggedIn: false,
    username: null,
    user_groups: [],
    application_name: null
  }
);

// SELECTORS
export const getUserState = state => state.user;
export const getLoginState = state => state.login;
export const isAdmin = state => {
  const login = state.login;
  return isRuleEngineAdmin(login && login.user_groups);
};
 
